export default __webpack_public_path__ + "static/media/1.8974efd8.JPG";